import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function PortalQuotes() {
  const { data: quotes = [] } = useQuery({ queryKey: ["portal-quotes"], queryFn: async () => (await api.get("/portal/quotes")).data });

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Quotes</h1>
      <p className="text-sm text-muted-foreground">Quotes and proposals shared with you.</p>
      <div className="mt-6 space-y-3">
        {quotes.length === 0 && (
          <div className="rounded-xl border border-dashed border-border p-10 text-center">
            <FileText className="mx-auto h-8 w-8 text-muted-foreground" />
            <p className="mt-3 text-sm text-muted-foreground">No quotes yet. Request a quote and it will appear here once prepared.</p>
            <Button asChild className="mt-4 rounded-full"><Link to="/contact">Request a Quote</Link></Button>
          </div>
        )}
        {quotes.map((q) => (
          <div key={q.id} className="flex items-center justify-between bs-card p-5">
            <div><h3 className="font-display font-bold">{q.title}</h3><p className="text-sm text-muted-foreground">${(q.amount || 0).toLocaleString()}</p></div>
            <Badge variant="secondary">{q.status}</Badge>
          </div>
        ))}
      </div>
    </div>
  );
}
